/** Must match `DEFAULT_USD_TO_BDT` in `apps/api` env (see `apps/api/src/config/env.ts`). */
export const DEFAULT_USD_TO_BDT = 124;
